<div class="fwa-container">

  <!--<div class="flex flex-vert-center flex-horiz-space-bw p-b-20">
    <div>
      <label class="col-grey-light d-b">Stage</label>
      <nz-radio-group [(ngModel)]="userType" nzButtonStyle="solid" [nzSize]="'default'" (ngModelChange)="change('stage')">
        <label nz-radio-button [nzValue]="u.id" *ngFor="let u of userTypes">{{u.name}}</label>
      </nz-radio-group>
    </div>
     <div>
      <label class="col-grey-light d-b">Sample</label>
      <nz-radio-group [(ngModel)]="dataSample" nzButtonStyle="solid" [nzSize]="'default'" (ngModelChange)="change('data')">
        <label nz-radio-button [nzValue]="d" *ngFor="let d of dataSamples">{{d}}</label>
      </nz-radio-group>
    </div>
  </div> -->

  <div class="pos-relative d-b w-100">
    <div class="fwa-summary-section grid grid-3x grid-3x-responsive p-20 grid-gap-20">
      <div class="fwa-summary-block fwa-summary-block-grid">
        <div>
          <h5><em nz-icon nzType="security-scan"></em> {{'Fraud propensity' | MMSTranslate}}</h5>
          <p class="col-grey-light">
           {{' Fraud propensity score is the measure of the probability of fraud. The higher the score, the higher the chance of fraud.' | MMSTranslate}}
          </p>
          <p *ngIf="dataTransformService.fraudRisk" class="col-grey-light">Fraud risk is <span class="f-w-700">{{dataTransformService.fraudRisk}}</span></p>
        </div>
        <!-- getColor(fraudIO.rating) -->
        <div class="flex flex-both-center h-100-pc">
          <nz-progress *ngIf="dataTransformService.fraudScore;else defaultFraudScore" [nzPercent]="dataTransformService.fraudScore" nzType="dashboard" [nzWidth]="96" [nzFormat]="getFraudPropensity" [nzStrokeColor]="fraudIO.color">
          </nz-progress>
          <ng-template #defaultFraudScore>
            <nz-progress [nzPercent]="fraudScore" nzType="dashboard" [nzWidth]="96" [nzFormat]="getFraudPropensity" [nzStrokeColor]="fraudIO.color">
            </nz-progress>
          </ng-template>
        </div>
      </div>
      <div class="fwa-summary-block fwa-summary-block-grid">
        <div>
          <h5><em nz-icon nzType="warning"></em> {{'Risk Score' | MMSTranslate}}</h5>
          <p class="col-grey-light">
            {{'The risk score is calculated based on various factors like Timelag in intimation, Intimation location, Branch Location,
                Product Name, Age of Life Assured, Occupation, Income, Type of U/W, risk Score at UW, Claim Liability and many more.' | MMSTranslate}}
            <!-- !!!!!! IMPORTANT NOTE TO DEV.: MAKE HARD-CODED RANGE VALUES TO DYNAMIC VARS -->
            <!-- <code>>70</code> {{'is high risk' | MMSTranslate}},
            <code>25-70</code> {{'is medium risk and' | MMSTranslate}}
            <code><25</code> {{'is low risk' | MMSTranslate}} -->
          </p>
        </div>
        <div class="flex flex-both-center h-100-pc">
          <!-- !!!!! IMPORTANT NOTE TO DEV.: MAKE HARD-CODED RANGE BELOW (70) TO DYNAMIC VARS -->
          <nz-progress *ngIf="dataTransformService.propensityRisk;else defaultRiskScore" [nzPercent]="dataTransformService.propensityRisk" nzType="dashboard" [nzWidth]="96" [nzFormat]="getRiskValue" [nzStrokeColor]="fraudIO.color">
          </nz-progress>
         <ng-template #defaultRiskScore>
          <nz-progress [nzPercent]="getRiskValue" nzType="dashboard" [nzWidth]="96" [nzFormat]="getRiskValue" [nzStrokeColor]="fraudIO.color">
          </nz-progress>
          </ng-template>
        </div>
      </div>
      <div class="fwa-summary-block" *ngIf="userDetails && userDetails.recommendation ;else defaultRecommendation">
      <!-- <div class="fwa-summary-block"> -->

        <h5><em nz-icon nzType="safety"></em> {{'Recommended action' | MMSTranslate}}</h5>
          
          <ul class="col-grey-light" style="list-style: disc; margin-left: 17px;">
          <li>{{userDetails.recommendation}}</li>
        </ul>
        <p class="col-grey-light">
          * {{'System recommended action is based on heuristic data and AI/ML data models' | MMSTranslate}}
        </p>
      </div>
      <ng-template #defaultRecommendation>
      <div class="fwa-summary-block">
        <h5><em nz-icon nzType="safety"></em> {{'Recommended action' | MMSTranslate}}</h5>
        <!-- <h3>{{fraudIO?.recommendation}}</h3> -->
        <ul class="col-grey-light" style="list-style: disc; margin-left: 17px;">
          <li>Send for investigation.</li>
        </ul>
        <p class="col-grey-light">
          * {{'System recommended action is based on heuristic data and AI/ML data models' | MMSTranslate}}
        </p>
      </div>
      </ng-template>
    </div>
    <div class="fwa-preload flex flex-both-center" *ngIf="isLoading">
      <div class="flex flex-dir-col flex-both-center" style="width:400px" (click)="isLoading=false">
        <h5>
          <span><span [innerText]="isLoadingText">{{'Analyzing' | MMSTranslate}}</span> ...</span>
        </h5>
        <nz-progress class="w-100-pc" [nzPercent]="isLoadingPerc" nzStatus="active"></nz-progress>
      </div>
    </div>
  </div>


  <nz-spin [nzSpinning]="isLoading" *ngIf="false">

    <nz-collapse [nzBordered]="false" class="ant-collapse-fwa">

      <!-- ANOMALIES  [nzActive]="true"-->
      <nz-collapse-panel *ngIf="enableAnomalyPanel" [nzHeader]="tmplANA" nzActive="true">
        <ng-template #tmplANA><span class="fwa-subh"><em nz-icon nzType="deployment-unit" nzTheme="outline"></em> {{'Anomalies' | MMSTranslate}}</span></ng-template>
        <div>

          <!-- Stacked bar [NOT USED] -->
          <div *ngIf="false">
            <div class="pos-relative" style="min-height: 38px">
              <ngx-charts-bar-horizontal-stacked
                [view]="viewHorizBar"
                [scheme]="colorScheme"
                [results]="multi"
                [gradient]="gradient"
                [xAxis]="showXAxis"
                [yAxis]="showYAxis"
                [legend]="showLegend"
                [showXAxisLabel]="showXAxisLabel"
                [showYAxisLabel]="showYAxisLabel"
                [xAxisLabel]="xAxisLabel"
                [yAxisLabel]="yAxisLabel"
                (select)="onChartClick($event)">
              </ngx-charts-bar-horizontal-stacked>
            </div>
          </div>

          <!-- Tags + Contributions % -->
          <div class="grid-tags-deets" *ngIf="!isLoading">
            <div class="ui-tags" *ngIf="!isLoading">
              <ng-container *ngFor="let d of fraudIO.cna">
                <div class="ui-tag clickable"
                     [ngClass]="{'ui-tag-selected':cnaSelected&&cnaSelected.id===d.id}"
                     (click)="calcna(d)" [style.background]="d.bg" [style.color]="d.color" [style.borderColor]="d.color"
                     nz-tooltip [nzTooltipTitle]="'Severity: '+d.severity|titlecase" nzTooltipPlacement="top" nzTooltipMouseEnterDelay="1.750">
                  {{d.name}}
                </div>
              </ng-container>
            </div>
            <div class="fwa-contributions">
              <ng-container *ngIf="cnaSelected&&cnaSelected.type!=='all'">
                <h1 class="f-s-1-1r p-0 m-0 col-grey-dark">
                  {{cnaSelected.name}}
                  <span *ngIf="cnaSelected.type==='cluster'" class="col-grey-light">{{'Cluster' | MMSTranslate}}</span>
                </h1>
                <div class="p-b-15">
                  <nz-statistic [nzValue]="(cnaSelected.contribution|number)!" [nzTitle]="" [nzSuffix]="'%'"></nz-statistic>
                  <small class="col-grey-light">{{'Contribution to Fraud Propensity Score' | MMSTranslate}}</small>
                </div>
              </ng-container>
            </div>
            <div class="fwa-graph">
              <div style="margin-top: -25px">
              <ngx-charts-pie-chart class="chart-container" [view]="pieView" [scheme]="colorScheme"
                [results]="pie" [legend]="false" [explodeSlices]="false" [labels]="true" [doughnut]="false">
              </ngx-charts-pie-chart>
              </div>
            </div>
          </div>
          <!-- Table for detailed view -->
          <nz-spin [nzSpinning]="isLoadingCnA">
            <!-- Selected Details -->
            <div class="ui-tag-details__p-20__" *ngIf="cnaSelected">

              <!-- TABLE: CLUSTERS -->
              <div class="cna-table-holder">
                <nz-table nzSize="small" [nzShowPagination]="false" [nzData]="[19,86,90,92]" class="p-b-40">
                  <thead>
                  <tr>
                    <th scope="col" style="max-width:520px" nzCustomFilter> {{'Scenario' | MMSTranslate}}
                      <nz-filter-trigger [nzDropdownMenu]="menu">
                        <i nz-icon nzType="search"></i>
                      </nz-filter-trigger>
                     <!-- <em nz-th-extra class="ant-table-filter-icon" nz-icon nz-dropdown #dropdown="nzDropdown"
                      nzType="search" [nzDropdownMenu]="menu" [class.ant-table-filter-open]="dropdown.nzVisible"
                      nzTrigger="click" nzPlacement="bottomRight" [nzClickHide]="false" nzTableFilter></em> -->

                      </th>
                    <th scope="col" style="min-width: 200px" nzCustomFilter>{{'Cluster' | MMSTranslate}}
                      <nz-filter-trigger [nzDropdownMenu]="menuCluster">
                        <i nz-icon nzType="search"></i>
                      </nz-filter-trigger>
                     <!-- <em nz-th-extra class="ant-table-filter-icon" nz-icon nz-dropdown #dropdown="nzDropdown"
                      nzType="search" [nzDropdownMenu]="menuCluster" [class.ant-table-filter-open]="dropdown.nzVisible"
                      nzTrigger="click" nzPlacement="bottomRight" [nzClickHide]="false" nzTableFilter></em> -->
                    </th>
                    <ng-container *ngIf="transactionState=='claimInvestigation'">
                      <th scope="col">{{'Investigation Finding' | MMSTranslate}}</th>
                      <th scope="col">{{'Investigator Remarks' | MMSTranslate}}</th>
                    </ng-container>
                    <ng-container *ngIf="userType=='adjudicator-post-investigation'">
                      <th scope="col">{{'Investigation Finding' | MMSTranslate}}</th>
                      <th scope="col">{{'Investigator Remarks' | MMSTranslate}}</th>
                    </ng-container>
                  </tr>
                  </thead>
                  <tbody>
                  <!-- Zero? -->
                  <tr *ngIf="cnaTableData.anomalies&&!cnaTableData.anomalies.length">
                    <td colspan="30">
                      <span class="flex flex-both-center p-t-b-10 flex-dir-col">
                       <em nz-icon nzType="file-protect" nzTheme="outline" class="f-s-2-2r col-grey-light m-b-5 d-i-b"></em>
                        <span>{{'Not contributing to Fraud Propensity' | MMSTranslate}}</span>
                      </span>
                    </td>
                  </tr>
                  <!-- Rows -->
                  <tr *ngFor="let d of cnaTableData.anomalies | slice: 0:15; let i = index">
                    <td>
                      {{d.message}} 
                      <span class="col-grey-light" nz-popover nzPopoverTitle="General Info" [nzPopoverContent]="d.info" nzPopoverPlacement="right">
                     <em nz-icon nzType="info-circle" class="col-grey-light"></em>
                    </span>
                    </td>
                    <td>
                      {{d.cluster}}
                    </td>

                    <ng-container *ngIf="transactionState=='claimInvestigation'">
                    <td>
                      <!-- Status of Investigation-->
                      <nz-select [(ngModel)]="d.invStatus" nzAllowClear nzPlaceHolder="Select" style="width:150px">
                        <nz-option nzValue="fraud" nzLabel="Fraud"></nz-option>
                        <nz-option nzValue="non-fraud" nzLabel="Non-Fraud"></nz-option>
                        <nz-option nzValue="pending" nzLabel="Not Applicable"></nz-option>
                        <nz-option nzValue="na" nzLabel="Not Applicable"></nz-option>
                      </nz-select>
                    </td>
                    <td>
                      <span>
                        <textarea rows="1" nz-input [(ngModel)]="d.invRemarks" [nzAutosize]="true"></textarea>
                      </span>
                    </td>
                    </ng-container>

                    <ng-container *ngIf="userType=='adjudicator-post-investigation'">
                    <td>
                      <!-- Status of Investigation-->
                      <span *ngIf="d.invStatus=='fraud'" class="col-red">{{'Verified as Fraud' | MMSTranslate}}</span>
                      <span *ngIf="d.invStatus=='non-fraud'" class="col-green-darker">{{'Verified as Non-fraud' | MMSTranslate}}</span>
                      <span *ngIf="d.invStatus=='pending'" class="col-grey-light">-</span>
                      <span *ngIf="d.invStatus=='na'" class="col-grey-light" style="font-style: italic">{{'Not Applicable' | MMSTranslate}}</span>
                    </td>
                    <td>
                      <span>{{d.invRemarks}}</span>
                    </td>
                    </ng-container>

                  </tr>
                  </tbody>
                </nz-table>
              </div>

            </div>
            <!-- No selection case: -->
            <p class="col-grey-light p-t-15 p-l-r-0" *ngIf="!cnaSelected">
             <em style="font-style: italic">* {{'Select a tag above to view detailed breakdown' | MMSTranslate}}</em>
            </p>
          </nz-spin>
        </div>
      </nz-collapse-panel>

      <nz-collapse-panel *ngIf="enableFraudRulePanel" [nzHeader]="tmplRU" nzActive="true">
        <ng-template #tmplRU><span class="fwa-subh"><em nz-icon nzType="cluster"></em> {{'Fraud Rules' | MMSTranslate}}</span></ng-template>
        <!-- RULES -->
        <div class="p-t-10"><!--spacer,small--></div>
        <!-- UI Rules Component (extended to include 'fraud' cases)  -->
        <div class="w-100-pc p-b-40" *ngIf="!isLoading">
        <app-ui-rules-auto-demo [enableCategories]="false" [IO]="_IO" [transactionState]="transactionState"
        (componentOutput)="BaseEmitHandler($event)" type="fraud" [fraudUserType]="userType">
       </app-ui-rules-auto-demo> 

          <!-- <app-rules-auto> </app-rules-auto> -->

        </div>
      </nz-collapse-panel>
      <!-- <ng-container *ngIf="userType=='investigator'||userType=='adjudicator-post-investigation'"> -->
      <ng-container *ngIf="transactionState=='claimInvestigation'">
      <nz-collapse-panel [nzHeader]="tmplFinv" nzActive="true">
        <ng-template #tmplFinv><span class="fwa-subh"><em nz-icon nzType="security-scan"></em> {{'Investigation' | MMSTranslate}}</span></ng-template>
        <!-- INV -->
        <div class="p-t-10"><!--spacer,small--></div>
        <div class="w-100-pc p-b-40">
          <div class="grid grid-3x grid-gap-20" [ngClass]="{'inputs-are-disabled':userType=='adjudicator-post-investigation'}">
            <div class="fwa-summary-block fwa-summary-block-inv">
              <h5>{{'Overall Status of Investigation' | MMSTranslate}}</h5>
              <div class="p-t-b-10">
                <nz-radio-group [(ngModel)]="dataInv.status" nzButtonStyle="solid" [nzSize]="'default'">
                  <label nz-radio-button [nzValue]="s" *ngFor="let s of dataInv.statusDATA">{{s|titlecase}}</label>
                </nz-radio-group>
              </div>
              <label for="inv-rem">{{'Remarks' | MMSTranslate}}</label>
              <textarea name="inv-rem" id="inv-rem" cols="30" rows="3" nz-input [(ngModel)]="dataInv.statusRemarks"></textarea>
            </div>
            <div class="fwa-summary-block fwa-summary-block-inv">
              <h5>{{'Overall Reason for Rejection' | MMSTranslate}}</h5>
              <nz-select [(ngModel)]="dataInv.overallReasons" nzSize="large" nzMode="tags" nzPlaceHolder="Select Reason(s)" class="w-100-pc p-t-b-10">
                <nz-option *ngFor="let o of dataInv.overallReasonsDATA" [nzLabel]="o" [nzValue]="o"></nz-option>
              </nz-select>
            </div>
            <div class="fwa-summary-block fwa-summary-block-inv">
              <h5>{{'Rejection Responsibility' | MMSTranslate}}</h5>
              <nz-select [(ngModel)]="dataInv.responsibility" nzSize="large" nzMode="tags" nzPlaceHolder="Select Reason(s)" class="w-100-pc p-t-b-10">
                <nz-option *ngFor="let o of dataInv.responsibilityDATA" [nzLabel]="o" [nzValue]="o"></nz-option>
              </nz-select>
            </div>
          </div>
        </div>
      </nz-collapse-panel>
      </ng-container>

    </nz-collapse>

    <div class="p-t-40"><!-- Spacer@end --></div>

    <nz-dropdown-menu #menu="nzDropdownMenu">
    <div class="search-box">
      <input type="text" nz-input placeholder="Search Rule" [(ngModel)]="searchValue" />
      <button nz-button nzSize="small" nzType="primary" (click)="searchRules(searchValue)"
        class="search-button">
        {{'Search' | MMSTranslate}}
      </button>
      <button nz-button nzSize="small" (click)="reset()">{{'Reset' | MMSTranslate}}</button>
    </div>
  </nz-dropdown-menu>

  <nz-dropdown-menu #menuCluster="nzDropdownMenu">
    <div class="search-box">
      <input type="text" nz-input placeholder="Search Rule" [(ngModel)]="searchValue" />
      <button nz-button nzSize="small" nzType="primary" (click)="searchCluster(searchValue)"
        class="search-button">
        {{'Search' | MMSTranslate}}
      </button>
      <button nz-button nzSize="small" (click)="resetCluseter()">{{'Reset' | MMSTranslate}}</button>
    </div>
  </nz-dropdown-menu>

  </nz-spin>

  

</div>

